<template>
  <div
  v-if="data.item !== undefined">
    <div v-if="this.btnSpinGetDetail == false">
      <v-btn :color="ui.bkgdColor" @click="getDetailDocument()"
              icon v-if="data.size == 'icon'">
        <v-icon :color="ui.btnColor"> source </v-icon>
      </v-btn>
      <v-btn :color="ui.btnColor" @click="getDetailDocument()"
              flat v-if="data.size == 'flat'">
        <v-icon left> {{btnObj.icon}} </v-icon>
          {{btnObj.title}}
      </v-btn>
    </div>
    <div v-else>
      <BtnSpin v-if="data.size == 'icon'" :btnSpec="btnInfo1"/>
      <BtnSpin v-if="data.size == 'flat'" :btnSpec="btnInfo2"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";

export default {
  mixins: [
    uisettings,
    dataSources,
    getData,
    storeFunctions,
    describeDocument,
    accessFunctions
  ],
  components: {
    BtnSpin
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      "getDetail",
      "getTreeInfo",
      "getCurrentPage",
      "getTreeMasterInfo",
      "getInfoCard"
    ]),
    ui() {
      return this.uiTheme1;
    },
    btnObj() {
      let obj = {
        icon: "",
        title: ""
      };
      if (this.data.tag === "LINK") {
        let tag = this.data.stag;
        if (tag !== undefined && tag !== null) {
          if (this.getTreeInfo !== null && this.getTreeInfo !== undefined) {
            obj.icon = "emoji_transportation";
            if (this.getCurrentPage === "/assetdetail") {
              // EMBEDDED ITEM ?
              if (this.getInfoCard !== null) {
                let embeddedTag = this.getInfoCard.basic.tag;
                obj.icon = this.defineDocumentFromTag(embeddedTag).icon;
                obj.title = this.defineDocumentFromTag(embeddedTag).title;
              } else {
                obj.title = "Asset";
                obj.icon = "emoji_transportation";
              }
            } else {
              obj.title = "Asset " + this.getTreeMasterInfo.id;
            }
          } else {
            obj.icon = this.defineDocumentFromTag(tag).icon;
            obj.title = this.defineDocumentFromTag(tag).title;
          }
        } else {
          obj.icon = "adjust";
          obj.title = "Source";
        }
      } else if (this.data.tag === "W.TOOL") {
        obj.icon = "work";
        obj.title = "build";
      } else if (this.data.tag === "INFO") {
        // let stag = this.data.item.stag;
        // obj.icon = this.defineDocumentFromTag(stag).icon;
        // obj.title = this.defineDocumentFromTag(stag).title;
        obj.icon = "info_outline";
        obj.title = "Detail";
      } else if (this.data.tag === "G1") {
        obj.icon = "key";
        obj.title = "Access";
      } else if (this.data.tag === "B3" || this.data.tag === "U1.B3") {
        obj.icon = "source";
        obj.title = "Action";
      } else if (this.data.tag === "B1") {
        obj.icon = "source";
        obj.title = "Risk";
      } else if (this.data.tag === "B4") {
        obj.icon = "source";
        obj.title = "Budget";
      } else if (this.data.tag === "B6") {
        obj.icon = "source";
        obj.title = "Plan";
      } else if (this.data.tag === "Q1") {
        obj.icon = "source";
        obj.title = "Order";
      } else if (this.data.tag === "C1") {
        obj.icon = "source";
        obj.title = "Detail";
      } else if (this.data.tag === "F1") {
        obj.icon = "source";
        obj.title = "detail";
      } else if (this.data.tag === "A1") {
        if (this.getTreeInfo !== null && this.getTreeInfo !== undefined) {
          obj.icon = "emoji_transportation";
          obj.title = "Asset";
        } else {
          obj.icon = "source";
          obj.title = "Asset";
        }
      } else if (this.data.tag === "O1") {
        obj.icon = "source";
        obj.title = "Ops";
      } else if (this.data.tag === "M2") {
        obj.icon = "source";
        obj.title = "Strategy";
      } else if (this.data.tag === "M5") {
        obj.icon = "source";
        obj.title = "Plan";
      } else if (this.data.tag === "M7") {
        obj.icon = "source";
        obj.title = "Call";
      } else if (this.data.tag === "W1") {
        obj.icon = "source";
        obj.title = "Work";
      } else if (this.data.tag === "W2") {
        obj.icon = "source";
        obj.title = "Work";
      } else if (this.data.tag === "W3") {
        obj.icon = "source";
        obj.title = "Resource";
      } else if (this.data.tag === "W6") {
        obj.icon = "source";
        obj.title = "Task";
      } else if (this.data.tag === "E6") {
        obj.icon = "source";
        obj.title = "Program";
      } else if (this.data.tag === "E8") {
        obj.icon = "add_chart";
        obj.title = "Result";
      } else if (this.data.tag === "E2") {
        obj.icon = "source";
        obj.title = "Engineering";
      } else if (this.data.tag === "E1") {
        obj.icon = "source";
        obj.title = "Equipment";
      } else if (this.data.tag === "L1") {
        obj.icon = "category";
        obj.title = "Material";
      } else if (this.data.tag === "L2") {
        obj.icon = "source";
        obj.title = "BOM";
      } else if (this.data.tag === "S1") {
        obj.icon = "source";
        obj.title = "Hazard";
      } else if (this.data.tag === "S6") {
        obj.icon = "source";
        obj.title = "Event";
      } else if (this.data.tag === "U1") {
        obj.icon = "source";
        obj.title = "Detail";
      }
      return obj;
    }
  },
  data() {
    return {
      valid: false,
      btnSpinGetDetail: false,
      btnInfo1: {
        color: "red",
        icon: "home",
        name: "add user",
        btnType: "icon"
      },
      btnInfo2: {
        color: "red",
        icon: "home",
        name: "add user",
        btnType: "flat"
      }
    };
  },
  methods: {
    getDetailDocument() {
      this.btnSpinGetDetail = true;
      let tag = this.data.tag; // target tag
      let did = null;
      if (tag === "INFO") {
        // console.log("");
        // console.log(">>> INFO <<<");
      } else if (this.data.item !== null && this.data.tag !== "LINK") {
        let docTag = this.data.item.basic.tag;
        let docData = this.data.item;
        did = this.data.item.basic.did;
        // console.log("");
        // console.log(">>> GET DETAIL THEN PAGE XXX <<<");
        // console.log("TAG :" + docTag);
        // console.log("DID :" + did);
        // console.log(docData);
        // reset store
        this.resetStore();
        // ACCESS CHECK
        if (docTag === "G1") {
          if (tag === "C1") {
            this.getDocumentDirectThenPage(tag, did, null);
          } else if (tag === "F1") {
            this.getDocumentDirectThenPage(tag, did, null);
          } else {
            // Update Compant or Facility did for access update if needed
            let itemDid = docData.char.did;
            let tag = docData.char.tag;
            if (tag === "C1") {
              this.getDocumentCompanyOnly(itemDid);
            } else {
              this.getDocumentFacilityOnly(itemDid);
            }
            // this.getDocumentDirect(docData.char.type, itemDid);
            // Generate G1 direct
            this.$store.dispatch("changeDetail", docData);
            this.$store.dispatch("changeDetailBasic", docData.basic);
            this.$store.dispatch("changeDetailChar", docData.char);
            this.$store.dispatch("changeDetailRev", docData.rev);
            this.$store.dispatch("changeTransitions", docData.trans);
            this.$router.push("/accessdetail");
          }
          // SOURCE
        } else {
          // console.log("");
          // console.log("GET DOC. DETAIL (NOT G1 {ACCESS} )");
          // console.log("TAG     :    " + docTag);
          // console.log("TITLE   :    " + docData.basic.title);
          // console.log("ARCHIVE :    " + docData.basic.ver);
          this.btnSpinGetDetail = true;
          // eslint-disable-next-line
          this.$store.dispatch("changeDataSavePendingIndication", false);
          if (docTag === "B3") {
            this.getActionDirectThenPage(this.data.item);
          } else {
            let arch = docData.basic.ver;
            // console.log("");
            // console.log("GET DOC. OR ARCHIVE DIRECT");
            // console.log("ARCHIVE : " + arch);
            // ALL OTHER DOCUMENTS or ARCHVE (arch = archived)
            if (arch !== null && arch !== undefined && arch !== "A") {
              // console.log("");
              // console.log("SELECTED GET DOC.");
              this.getDocumentDirectThenPage(docTag, did, null);
            } else if (arch !== null && arch !== undefined && arch === "A") {
              this.getArchiveDirectThenPage(docTag, did, null);
            } else {
              // do nothing
            }
          }
        }
      } else {
        if (tag === "C1") {
          did = this.getUser.pref.select.cdid;
        } else if (tag === "F1") {
          did = this.getUser.pref.select.fdid;
        } else if (tag === "B3") {
          did = this.data.did;
        } else if (tag === "U1") {
          did = this.getUser.basic.did;
        } else if (tag === "LINK" && this.data.stag !== "") {
          tag = this.data.stag;
          did = this.data.sdid;
        } else if (tag === "W.TOOL" && this.data.stag !== "") {
          tag = this.data.stag;
          did = this.data.sdid;
        } else {
          tag = this.data.stag;
          did = this.data.sdid;
          // tag = this.data.item.stag;
          // did = this.data.item.sdid;
        }
        // console.log("---- GET DOC DIRECT ----");
        // console.log(this.getDetailBasic.tag);
        // console.log(tag);
        // console.log(did);
        this.getDocumentDirectThenPage(tag, did, this.data.page);
      }
    }
  }
};
</script>
